export enum ListContentType {
    ITEM = 'item',
    SPECIMEN = 'specimen',
    CONTAINER = 'container',
    ACCESSORY = 'accessory',
}

export function getContentTypeFromTypeKey(typeKey: string): ListContentType | null {
    const cardTypeKeyMatcher = /^.+?([A-Z][a-z]+)/
    const cardTypeMatchResult = typeKey.match(cardTypeKeyMatcher)
    switch (cardTypeMatchResult && cardTypeMatchResult[1] && cardTypeMatchResult[1].toLowerCase()) {
        case 'museum':
            return ListContentType.ITEM
        case 'specimen': // Unused?
            return ListContentType.SPECIMEN
        case 'container':
            return ListContentType.CONTAINER
        case 'accessory':
            return ListContentType.ACCESSORY
        default:
            return null
    }
}

export function getClassNameFromContentTypeKey(typeKey: string): string {
    const cardTypeKeyMatcher = /^(.+?)([A-Z].+)/
    const cardTypeMatchResult = typeKey.match(cardTypeKeyMatcher)
    return cardTypeMatchResult?.length === 3
        ? `org.skinsoft.backend.types.item.${cardTypeMatchResult[2].toLowerCase()}.${cardTypeMatchResult[1].toLowerCase()}.${typeKey
              .charAt(0)
              .toLocaleUpperCase()}${typeKey.slice(1)}`
        : ''
}
